<template>
  <a-modal v-model="visible" title="添加格子" :footer="null">
    <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="用户名" prop="username" required>
        <a-input v-model="form.username" placeholder="输入用户名" />
      </a-form-model-item>
      <a-form-model-item label="电话号码" prop="mobile" required>
        <a-input v-model="form.mobile" placeholder="电话号码" />
      </a-form-model-item>
      <a-form-model-item label="所属公司" prop="company">
        <company-search mode="multiple" v-model="company" />
      </a-form-model-item>
      <a-form-model-item label="角色" prop="role">
        <a-select
          v-model="form.grants"
          mode="multiple"
          style="width: 100%"
          placeholder="选择角色"
        >
          <a-select-option v-for="item in roles" :key="item._id" :value="item._id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="密码" prop="mobile" required>
        <a-input v-model="form.password" placeholder="密码" type="password" />
      </a-form-model-item>
      <a-form-model-item label="管理员" prop="isAdmin" required v-super>
        <a-switch v-model="form.isAdmin" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="desc">
        <a-input v-model="form.desc" type="textarea" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 8 }">
        <a-button type="primary" @click="onSubmit">
          提交
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          重置
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import {
  addUser,
  modifyUser,
  getUserDetail,
} from '@/api/user';
import { getRole } from '@/api/settings';

export default {
  data() {
    return {
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      cabnums: [],
      other: '',
      company: [],
      roles: [],
      type: 'add',
      form: {
        isAdmin: false,
        username: '',
        password: '',
      },
      rules: {
        serial: [
          { required: true, message: '请输入格口编号', trigger: 'blur' },
          { type: 'number', message: '请输入数字', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择一个规格', trigger: 'change' },
        ],
        status: [
          { required: true, message: '请选择一个状态', trigger: 'change' },
        ],
        canuse: [
          { required: true, message: '请选择是否禁用', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.getRolesList();
  },
  methods: {
    show(type, id) {
      this.type = type;
      this.visible = true;
      if (id) this.getDetail(id);
    },
    async getRolesList() {
      const { data } = await getRole();
      this.roles = data;
    },
    async getDetail(id) {
      const { data } = await getUserDetail(id);
      this.company = data.company.map((item) => ({
        key: item.id,
        label: item.name,
      }));
      this.form = data;
    },
    async submit() {
      let res;
      const company = this.getCompanyKeys();
      if (this.type === 'add') {
        const { data } = await addUser({
          ...this.form,
          company,
        });
        res = data;
      } else {
        const { _id } = this.form;
        const { data } = await modifyUser(_id, {
          ...this.form,
          company,
        });
        res = data;
      }
      if (res) {
        this.$message.success('添加成功');
        this.visible = false;
        this.$emit('close');
      }
    },
    getCompanyKeys() {
      return this.company.map((item) => item.key);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          return this.submit();
        }
        console.log('error submit!!');
        return false;
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
